import { module } from "angular";
import { NotificationFilter } from "./NotificationFilter";

module("mmGui").filter("mmNotification", NotificationFilter);
